//telas externas
import admin from '../pages/admin/admin.vue'

import home from '../pages/publico/home.vue'
import resultadobusca from '../pages/publico/resultadoBusca.vue'
import autenticidade from '../pages/publico/autenticidade.vue'
import visualizacaoEdicao from '../pages/publico/visualizacaoEdicao.vue'
import visualizacaoAto from '../pages/publico/visualizacaoAto.vue'
import visualizacaoAnexoAto from '../pages/publico/visualizacaoAnexoAto.vue'

import expedienteView from '../pages/publico/expediente.vue'

import inicio from '../pages/admin/inicio/inicio.vue'
import edicao from '../pages/admin/edicao/edicao.vue'
import edicaoTabs from '../pages/admin/edicao/edicaoTabs.vue'
import categoriaAto from '../pages/admin/categoriaAto/categoriaAto.vue'
import categoriaAtoForm from '../pages/admin/categoriaAto/categoriaAtoForm.vue'
import expediente from '../pages/admin/expediente/expediente.vue'
import orgao from '../pages/admin/orgao/orgao.vue'



//Telas de erro
//import pagina403 from '../pages/erros/403.vue'
import pagina404 from '../pages/erros/404.vue'


const breadcrumbVisualizacao = (to, from, next) => {

    var textoVisualizacao = "";
   
    switch (to.name) {
        case 'visualizacaoEdicao':
            textoVisualizacao = 'Visualização da Edição';
            break;
        case 'visualizacaoAto':
            textoVisualizacao = 'Visualização do Ato';
            break;
        case 'visualizacaoAnexoAto':
            textoVisualizacao = 'Visualização do Anexo';
            break;
    }

    if (from.name === "resultadobusca") {
        to.meta.breadcrumb = [
            {
                text: 'Início',
                to: '/'
            },
            {
                text: 'Busca',
                to: from.fullPath
            },
            {
                text: textoVisualizacao,
            }
        ]
    } else {
        to.meta.breadcrumb = [
            {
                text: 'Início',
                to: '/'
            },
            {
                text: textoVisualizacao,
            }
        ]        
    }

    next();
}


const routes = [

    //ROTAS PUBLICAS
    {
        name: 'home',
        path: '/',
        component: home,
    },
    {
        name: 'resultadobusca',
        path: '/resultadobusca',
        component: resultadobusca,
        meta: {
            breadcrumb: [
                {
                    text: 'Início',
                    to: '/'
                },
                {
                    text: 'Busca',
                }
            ]
        },
    },

    {
        name: 'verificarautenticidade',
        path: '/verificarautenticidade/:codigo?',
        component: autenticidade,
        meta: {
            breadcrumb: [
                {
                    text: 'Início',
                    to: '/'
                },
                {
                    text: 'Verificar autenticidade',
                }
            ]
        },
    },

    {
        name: 'visualizacaoEdicao',
        path: '/visualizacao/edicao/:id',
        component: visualizacaoEdicao,        
        meta: {
            breadcrumb: []
        },
        beforeEnter: breadcrumbVisualizacao,
    },

    {
        name: 'visualizacaoAto',
        path: '/visualizacao/ato/:id',
        component: visualizacaoAto,        
        meta: {
            breadcrumb: []
        },

        /* eslint-disable */
        beforeEnter: breadcrumbVisualizacao,
    },

    {
        name: 'visualizacaoAnexoAto',
        path: '/visualizacao/anexoato/:id',
        component: visualizacaoAnexoAto,        
        meta: {
            breadcrumb: []
        },

        /* eslint-disable */
        beforeEnter: breadcrumbVisualizacao,
    },

    {
        name: 'expedienteview',
        path: '/expediente',
        component: expedienteView,
        meta: {
            breadcrumb: [
                {
                    text: 'Início',
                    to: '/'
                },
                {
                    text: 'Expediente',
                }
            ]
        },
    },


    //ROTAS PRIVADAS
    {
        path: '/admin',
        component: admin,
        children: [
            {
                name: 'inicio',
                path: '/',
                component: inicio,
                meta: {
                    breadcrumb: [
                        {
                            text: 'Início'
                        }
                    ]
                },
            },
            {
                name: 'edicoes',
                path: 'edicoes',
                component: edicao,
                meta: {
                    breadcrumb: [
                        {
                            text: 'Início',
                            to: '/admin'
                        },
                        {
                            text: 'Edições',
                        }
                    ]
                },
            },
            {
                name: 'edicaoTabs',
                path: 'edicoes/:id',
                component: edicaoTabs,
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'Início',
                            to: '/admin'
                        },
                        {
                            text: 'Edições',
                            to: '/admin/edicoes'
                        },
                        {
                            text: 'Edição'                
                        }
                    ]
                },
            },
            {
                name: 'edicaoTabsView',
                path: 'edicoes/visualizar/:id',
                component: edicaoTabs,
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'Início',
                            to: '/admin'
                        },
                        {
                            text: 'Edições',
                            to: '/admin/edicoes'
                        },
                        {
                            text: 'Edição'                
                        }
                    ]
                },
            },            
            {
                name: 'categoriasAto',
                path: 'categoriasato',
                component: categoriaAto,
                meta: {
                    breadcrumb: [
                        {
                            text: 'Início',
                            to: '/admin'
                        },
                        {
                            text: 'Categorias'
                        },
                    ]
                },
            },
            {
                name: 'categoriaAtoForm',
                path: 'categoriasato/:id',
                component: categoriaAtoForm,
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'Início',
                            to: '/admin'
                        },
                        {
                            text: 'Categorias',
                            to: '/admin/categoriasato'
                        },
                        {
                            text: 'Categoria'
                        },
                    ]
                },
            },
            {
                name: 'categoriaAtoFormView',
                path: 'categoriasato/visualizar/:id',
                component: categoriaAtoForm,
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'Início',
                            to: '/admin'
                        },
                        {
                            text: 'Categorias',
                            to: '/admin/categoriasato'
                        },
                        {
                            text: 'Categoria'
                        },
                    ]
                },
            },
            {
                name: 'expediente',
                path: 'expediente',
                component: expediente,
                meta: {
                    breadcrumb: [
                        {
                            text: 'Início',
                            to: '/admin'
                        },
                        {
                            text: 'Expediente'
                        },
                    ]
                },
            },
            {
                name: 'orgao',
                path: 'orgao',
                component: orgao,
                meta: {
                    breadcrumb: [
                        {
                            text: 'Início',
                            to: '/admin'
                        },
                        {
                            text: 'Orgãos'
                        },
                    ]
                },
            },
        ]

    },
 
    // {
    //     name: '403',
    //     path: '/403',
    //     component: pagina403,
    // },
    //tela "não encontrada"
    {
        name: '404',
        path: '/404',        
        component: pagina404,
    },
  
];

export default routes;